var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ModalStack"},[_vm._t("default"),_c('div',{staticClass:"h-stack"},[_vm._t("first-line")],2),_c('div',{staticClass:"h-stack"},[_vm._t("second-line")],2),_c('div',{staticClass:"h-stack"},[_vm._t("third-line")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }